import Dropdown from './Dropdown';
import Header from './Header';
import Menu from './Menu';

Dropdown.Header = Header;
Dropdown.Menu = Menu;

export default Dropdown;
